export default __webpack_public_path__ + "static/media/IBimageKneeanglemidstance1.3ad9d3a8.png";